"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _react2 = _interopRequireDefault(require("react"));
var _ = require("../../..");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SecondaryMenu = ({
  small,
  lightTheme,
  label,
  onMenuToggle,
  children
}) => {
  const theme = (0, _react.useTheme)();
  const isMobile = (0, _.useIsMobile)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    children: [!small && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ChildrenWrapper, {
      children: children
    }), (label || !isMobile) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CollapseWrapper, {
      open: !small,
      lightTheme: lightTheme,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        "aria-label": "Toggle meny",
        open: !small,
        lightTheme: lightTheme,
        theme: theme,
        onClick: () => onMenuToggle && onMenuToggle(small),
        "data-tracking-name": "Sidemenu",
        "data-tracking-event": 'Menu toggle: ' + (!small ? 'collapse' : 'expand'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconChevronLeft, {
          size: "9px",
          color: lightTheme ? (0, _.getContrastColor)(theme.illustrationPrimary10, theme.btnDefault) : 'white'
        })
      }), !small && label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
        size: "10px",
        children: label
      })]
    })]
  });
};
var _default = exports.default = SecondaryMenu;